import { useMemo } from 'react'

import { NotificationVerb } from 'src/shared/schemas/notifications'

type EnterpriseInvitationTitleProps = {
  notificationVerb: NotificationVerb | null
}

const EnterpriseInvitationTitle = ({ notificationVerb }: EnterpriseInvitationTitleProps) => {
  const text = useMemo(() => {
    if (!notificationVerb) {
      return "You've been invited!"
    }
    if (notificationVerb === NotificationVerb.ENTERPRISE_INVITATION_SENT) {
      return "You've been invited!"
    }
    if (notificationVerb === NotificationVerb.ENTERPRISE_INVITATION_ACCEPTED) {
      return "You've accepted an invitation!"
    }
    if (notificationVerb === NotificationVerb.ENTERPRISE_INVITATION_DECLINED) {
      return "You've declined an invitation!"
    }
    if (notificationVerb === NotificationVerb.ENTERPRISE_INVITATION_CANCELED) {
      return "You've canceled an invitation!"
    }
    if (notificationVerb === NotificationVerb.ENTERPRISE_INVITATION_EXPIRED) {
      return 'Your invitation has expired!'
    }
    return null
  }, [notificationVerb])

  return <p className="text-[13px] font-medium leading-[18px] text-primary">{text}</p>
}

export default EnterpriseInvitationTitle
